import { Linkedin } from "lucide-react";
import { useLang } from "@/lib/i18n";
import Portrait from "@/components/Portrait";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function LeaderDialog({ leader, open, onOpenChange }) {
  const { L, t } = useLang();
  if (!leader) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl border-border bg-card p-0" data-testid="leader-dialog">
        <div className="grid gap-0 sm:grid-cols-[200px_1fr]">
          <Portrait name={leader.name} photoUrl={leader.photo_url} className="h-56 w-full sm:h-full" monogramClass="text-5xl" />
          <div className="max-h-[70vh] overflow-y-auto p-7 md:p-9">
            <DialogHeader className="space-y-0 text-start">
              <p className="eyebrow mb-3">{L(leader.title)}</p>
              <DialogTitle className="font-head text-3xl md:text-4xl leading-tight" data-testid="leader-dialog-name">
                {leader.name}
              </DialogTitle>
            </DialogHeader>
            <p className="mt-5 text-muted-foreground leading-relaxed">{L(leader.bio)}</p>
            {leader.linkedin && (
              <a
                href={leader.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="leader-dialog-linkedin"
                className="btn-outline mt-7 h-10 px-5 text-xs"
              >
                <Linkedin className="h-3.5 w-3.5" /> {t("leader_profile")}
              </a>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
